// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__NjrZz","header":"Messages_header__3CPB1"};